var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theme-transition",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "theme-tranistion",
    clipPath: "url(#clip0_1_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 90.5895C80 89.1593 81.1549 88 82.5794 88H92.8972C94.3218 88 95.4766 89.1593 95.4766 90.5895V100.516C95.4766 101.946 94.3218 103.105 92.8972 103.105H82.5794C81.1549 103.105 80 101.946 80 100.516V90.5895ZM80 112.6C80 111.17 81.1549 110.011 82.5794 110.011H169.421C170.845 110.011 172 111.17 172 112.6V167.411C172 168.841 170.845 170 169.421 170H82.5794C81.1549 170 80 168.841 80 167.411V112.6ZM104.505 88C103.08 88 101.925 89.1593 101.925 90.5895V100.516C101.925 101.946 103.08 103.105 104.505 103.105H169.421C170.845 103.105 172 101.946 172 100.516V90.5895C172 89.1593 170.845 88 169.421 88H104.505Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 124,
    stroke: "#757572",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDev);
export default __webpack_public_path__ + "static/media/WebsiteDev.f2aeba5bf56affb171610ce1f1146903.svg";
export { ForwardRef as ReactComponent };